import React from 'react';
import { message, Tooltip, Tag } from 'antd';
import moment from 'moment';
import { FlagOutlined } from '@ant-design/icons';
import { getAllStatusByType } from 'apis/System/MasterData';
import { getAllMenu } from 'apis/System/UserManagement';
import constants from 'constants';

export const setLocalStorage = (key, value) => localStorage.setItem(
  key,
  typeof value === 'object' ? JSON.stringify(value) : value,
);

export const getLocalStorage = (key) => localStorage.getItem(key);

export const isEmptyObject = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object;

export const recursionOpenKeys = (items, openKeys, pathName) => {
  items.forEach((item) => {
    if (item.children && pathName.indexOf(item.url) !== -1) {
      openKeys.push(item.url);
      recursionOpenKeys(item.children, openKeys, pathName);
    }
  });
  return openKeys;
};

export const notification = (type, messageText) => {
  message[type](messageText);
};

export const renderColorByDeliveryStatus = (status) => {
  let color = '';
  let title = '';

  switch (status) {
    case '1':
      color = '#a1b7c4';
      title = 'Mới đặt hàng';
      break;

    case '2':
      color = '#f5c542';
      title = 'Đã đóng gói, chờ giao hàng';
      break;

    case '3':
      color = '#42b0ff';
      title = 'Đang giao hàng';
      break;

    case '4':
      color = '#008000';
      title = 'Đã giao hàng';
      break;

    case '5':
      color = '#ff0000';
      title = 'Hết hàng';
      break;

    default:
      break;
  }

  return (
    <Tooltip placement="topLeft" title={title}>
      <FlagOutlined style={{ color }} className="ml-20 cursor-pointer" />
    </Tooltip>
  );
};

export const setItemCommon = async (item) => {
  const itemCommon = await getAllStatusByType({
    type: item,
  });
  if (itemCommon && itemCommon.data) {
    localStorage.setItem(item, JSON.stringify(itemCommon.data));
  }
};

export async function setItemCommonLevelMenu(item) {
  const itemCommonLevelRoleMidTid = await getAllMenu({
    type: item,
  });
  if (itemCommonLevelRoleMidTid && itemCommonLevelRoleMidTid.data) {
    localStorage.setItem(item, JSON.stringify(itemCommonLevelRoleMidTid.data));
  }
}

export const renderStatusColor = (status) => {
  let color = null;
  switch (status) {
    case 'Success':
      color = '#4dbd74';
      break;
    case 'Fail':
      color = '#f86c6b';
      break;
    case 'Check':
      color = '#20a8d8';
      break;
    case 'Reversal P3':
      color = '#a569bd';
      break;
    case 'Khởi tạo':
      color = '#a569bd';
      break;
    case 'Hoạt động':
      color = '#4dbd74';
      break;
    case 'Chờ duyệt':
      color = '#20a8d8';
      break;
    case 'Từ chối':
      color = '#f5b041';
      break;
    case 'Tạm khóa':
      color = '#f86c6b';
      break;
    case 'Hết hạn':
      color = '#c0392b';
      break;
    case 'Đã đóng':
      color = '#f86c6b';
      break;
    case 'Chờ kích hoạt':
      color = '#20a8d8';
      break;
    default:
      break;
  }

  return color ? <Tag color={color}>{status}</Tag> : <span>{status}</span>;
};

export const convertStatusCode = (code, key) => {
  const statusList = getLocalStorage(key) && JSON.parse(getLocalStorage(key));
  const statusFiltered = statusList && statusList.filter((item) => item.code === code);

  return statusFiltered && statusFiltered.length > 0
    && renderStatusColor(statusFiltered[0].description);
};

export const convertMasterData = (field, value, key, resultField) => {
  const masterDataList = JSON.parse(getLocalStorage(key));
  const masterDataFiltered = masterDataList && masterDataList.length > 0
    && masterDataList.filter((item) => item[field] === value);

  return masterDataFiltered && masterDataFiltered.length > 0
    && (`${masterDataFiltered[0].typeCode}-${masterDataFiltered[0][resultField]}`);
};

export const numberWithDots = (dot) => dot && dot.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');

export const dummyRequest = ({ onSuccess }) => {
  setTimeout(() => {
    onSuccess('ok');
  }, 0);
};

export const getPathPosition = (string, subString, index) => string.split(subString, index)
  .join(subString).length;

export const renderAccountType = (type) => {
  switch (type) {
    case 1:
      return 'Merchant';
    case 2:
      return 'Điểm bán';
    case 3:
      return 'Chi nhánh Merchant';
    default:
      return '';
  }
};

export const renderInternationalQr = (type) => {
  switch (type) {
    case '1':
      return 'QR Quốc tế';
    case '2':
      return 'QR Nội địa';
    default:
      return type;
  }
};

export const renderInternationalQrcode = (type) => {
  switch (type) {
    case 1:
      return 'QR Quốc tế';
    case 0:
      return 'QR Nội địa';
    default:
      return type;
  }
};

export const paymentUnits = [
  { name: 'Tất cả', value: '' },
  { name: 'Vietinbank', value: constants.VIETINBANK_CODE },
  { name: 'Ngân hàng khác', value: 'OTHER' },
];

export const convertStatusTrans = (status) => {
  let color = null;
  let text = '';
  let backgroundColor = null;
  switch (status) {
    // Green
    case 18:
      color = '#29A339';
      backgroundColor = '#EEF6EF';
      text = 'Reversal timeout';
      break;
    case 13:
      color = '#29A339';
      backgroundColor = '#EEF6EF';
      text = 'Reversal P3';
      break;
    case 0:
      color = '#29A339';
      backgroundColor = '#EEF6EF';
      text = 'Pending reversal';
      break;
    case 17:
      color = '#F5F7F9';
      backgroundColor = '#5A7087';
      text = 'Reversal failed';
      break;
    // Purple
    case 2:
      color = '#29A339';
      backgroundColor = '#EEF6EF';
      text = 'Reversal manual';
      break;
    // Orange
    case 4:
      color = '#F5F7F9';
      backgroundColor = '#5A7087';
      text = 'Reversal rejected';
      break;
    case 16:
      color = '#29A339';
      backgroundColor = '#EEF6EF';
      text = 'Reversal auto';
      break;
    // Red
    default:
      color = '#C91D1D';
      backgroundColor = '#FAEAEA';
      break;
  }

  const styleStatus = {
    color,
    background: backgroundColor,
    borderRadius: '10px',
    display: 'inline-block',
    padding: '2px 8px',
  };

  return color
    ? (
      <span style={styleStatus}>
        {text}
      </span>
    ) : <span>{status}</span>;
};

export const checkRangeMonths = (fromDate, toDate, range, type = 'Tìm kiếm') => {
  const toDateMoment = moment(toDate, 'DD/MM/YYYY HH:mm:ss').subtract(range, 'months');
  const checkTime = new Date(moment(fromDate, 'DD/MM/YYYY HH:mm:ss')).getTime() < new Date(toDateMoment).getTime();
  const checkTimeError = moment(fromDate) > moment(toDate);
  if (checkTimeError) {
    notification('error', 'Từ ngày không được lớn hơn đến ngày');
  } else if (checkTime) {
    notification('error', `Khoảng thời gian ${type} trong vòng ${range} tháng.`);
  }
  return checkTime || checkTimeError;
};
